module.exports = __webpack_public_path__ + "img/clients-05.707940d6.svg";